import { call, put, select } from 'redux-saga/effects';
import { selectRestreamerStatus, stopRestreaming } from 'features/restreamer/restreamerSlice';
import { openModal } from 'features/modal/modalSlice';
import { eventBus } from 'utils/eventBus';
import { logger } from 'utils/logger';
import { RestreamerStatus } from 'features/restreamer/types';
import { signalingRestreamingFailure } from 'features/restreamer/actions';

export function* onRestreamingFailureSaga(action: ReturnType<typeof signalingRestreamingFailure>) {
  logger.remote().error('Restreaming failure');

  const reason = action.payload?.reason;

  yield call(eventBus.sendMessage, 'restreamingFailed', {}, reason ? { reason } : undefined);

  yield put(stopRestreaming());

  const restreamingStatus: RestreamerStatus = yield select(selectRestreamerStatus);
  if (restreamingStatus === 'started') {
    yield put(openModal('restreamingFailureRuntime'));
  } else {
    yield put(openModal('restreamingFailure'));
  }
}
